/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonEmployeeDataViewModel } from "../types/PersonEmployeeDataViewModel.ts";
import { eEmployeeTypeSchema } from "./eEmployeeTypeSchema.ts";

export const personEmployeeDataViewModelSchema = z.object({
  employeeId: z.optional(
    z.number().int().describe("ID do registro de funcionário."),
  ),
  personId: z.optional(
    z.number().int().describe("ID da pessoa associada ao funcionário."),
  ),
  postId: z
    .number()
    .int()
    .describe("ID do cargo do funcionário. Opcional.")
    .nullish(),
  postDescription: z
    .string()
    .describe("Descrição do cargo do funcionário.")
    .nullish(),
  codeBadge: z.string().describe("Código do crachá do funcionário.").nullish(),
  dateStart: z
    .string()
    .datetime()
    .describe("Data de início do vínculo empregatício. Opcional.")
    .nullish(),
  dateFinish: z
    .string()
    .datetime()
    .describe("Data de encerramento do vínculo empregatício. Opcional.")
    .nullish(),
  type: z.optional(
    z
      .lazy(() => eEmployeeTypeSchema)
      .describe("0 = Internal | 1 = External | "),
  ),
  typeName: z
    .string()
    .describe("Nome legível do tipo de funcionário.")
    .nullish(),
  serviceRequestNotification: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o funcionário recebe notificações de requisições de serviço.",
      ),
  ),
}) as unknown as ToZod<PersonEmployeeDataViewModel>;
